import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M10.75 20V4.75L14.75 4.75M14.75 20V4.75M14.75 4.75H18.5" vectorEffect="non-scaling-stroke" />
		<Path d="M5.75 9C5.75 11.3472 7.65279 13.25 10 13.25H10.75V4.75H10C7.65279 4.75 5.75 6.65279 5.75 9Z" fill="currentColor" vectorEffect="non-scaling-stroke" />
	</SVG>
);
